module.exports = __webpack_public_path__ + "static/media/share.6c1e6665.png";